'use client'

import React from 'react'
// import { SwiperSlide } from 'swiper/react'

// import ZSwiper from '@/_components/universal/swiper/z-swiper'
import { useSectionParams } from '@/_i18n/section-params'

import AAPCard from './components/a-ap-category-card'
import { IAnnualProgram } from './components/a-ap-category-card'

interface IZAPCategoriesListProps {
	title: string
	subtitle: string
	description: string
	programs: IAnnualProgram[]
}

const ZAPCategoriesList: React.FC<IZAPCategoriesListProps> = ({
	title,
	subtitle,
	description,
	programs
}) => {
	const { getSectionParams } = useSectionParams('annualPrograms')

	return (
		// bg0 pdt-100 pdt-0lg pdb-130 pdb-60lg pos_rel
		<section
			className='bg0 pdt-100 pdt-0lg pdt-60lg pdb-130 pdb-60lg pos_rel'
			id={getSectionParams('chooseProgramCategory')}
		>
			<div className='wrapper'>
				<div className='section_head'>
					<h2 className='title_side text_uc'>{title}</h2>
					<h3 className='title_h1'>{subtitle}</h3>
					<div className='page_content reset_margins nobalance'>
						<p>{description}</p>
					</div>
				</div>
			</div>

			<div className='wrapper2 mgt-40 mgt-30lg'>
				<div className='grid grid-cols-2 lg:grid-cols-4 gap-3 max-w-[660px] mx-auto lg:max-w-none'>
					{programs.map(program => (
						<AAPCard key={program.id} program={program} />
					))}
				</div>
			</div>
		</section>
	)
}

export default ZAPCategoriesList
